<section class="container-fluid bg-white">
    <!--- header -->
    <header class="row">
        <div class="col-xl-3 col-12 d-flex align-items-center" [ngClass.sm]="'pt-1'" [ngClass.md]="'pt-1'">
            <img src="../assets/images/logo/nepta.svg" alt="brand-logo" height="28"/>
        </div>
        <div class="col-xl-9 col-12 px-xl-0">
            <app-onboarding-header></app-onboarding-header>
        </div>
    </header>
    <!--- body -->
    <div class="row" id="main-container">
        <div class="col-md-9 offset-md-3 pt-2 position-relative">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-12">
                    <h1>{{"FOREIGN_LANGUAGES" | translate}}</h1>
                    <small>{{"INSERT.FOREIGN_LANGUAGES" | translate}}</small>
                </div>
                <div class="col-lg-6 col-md-6 col-12 text-lg-right text-md-right text-left">
                    <span (click)="showVideo()" [ngbTooltip]="'SHOW_TUTORIAL'|translate" placement="top" class="cursor-pointer text-primary">{{'DONT_KNOW_HOW_TO_DO'|translate}}</span>
                </div>
            </div>
            <div class="row align-items-center py-2 pr-md-2 border-bottom" *ngFor="let item of items_languages; let i = index">
                <div class="form-group col-12 col-md-4">
                    <label [for]="'name_'+i">{{"LANGUAGE" | translate}}</label>
                    <ng-select [id]="'name_'+ i" [(ngModel)]="item.name" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                        <ng-option *ngFor="let language of languages_list" [value]="language">{{language}}</ng-option>
                    </ng-select>
                </div>
                <div class="form-group col-md-3 col-12">
                    <label [for]="'speak_'+i">{{"LEVEL_SPEAK" | translate}}</label>
                    <ng-select [id]="'speak_'+ i" [(ngModel)]="item.speak" [searchable]="false" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                        <ng-template ng-label-tmp let-item="item" *ngIf="item.speak">
                            <span>{{item}} - {{'LANGUAGE_LEVELS.' + item + '.LABEL' | translate}}</span>
                        </ng-template>
                        <ng-option *ngFor="let level of language_levels" [value]="level">
                            <strong>{{level}} - {{'LANGUAGE_LEVELS.' + level + '.LABEL' | translate}}</strong>
                            <p class="white-space-break">{{'LANGUAGE_LEVELS.' + level + '.DESCRIPTION' | translate}}</p>
                        </ng-option>
                    </ng-select>
                </div>
                <div class="form-group col-md-3 col-12">
                    <label [for]="'write_'+i">{{"LEVEL_WRITE" | translate}}</label>
                    <ng-select [id]="'write_'+i" [(ngModel)]="item.write" [searchable]="false" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                        <ng-template ng-label-tmp let-item="item" *ngIf="item.write">
                            <span>{{item}} - {{'LANGUAGE_LEVELS.' + item + '.LABEL' | translate}}</span>
                        </ng-template>
                        <ng-option *ngFor="let level of language_levels" [value]="level">
                            <strong>{{level}} - {{'LANGUAGE_LEVELS.' + level + '.LABEL' | translate}}</strong>
                            <p class="white-space-break">{{'LANGUAGE_LEVELS.' + level + '.DESCRIPTION' | translate}}</p>
                        </ng-option>
                    </ng-select>
                </div>
                <!----------------------------------------------------Buttons------------------------------------------>
                <div class="col-md-2 col-12 d-flex align-items-center" [ngClass.xl]="'justify-content-end'" [ngClass.md]="'justify-content-end'" *ngIf="items_languages.length > 0">
                    <button (click)="addItem()" type="button" class="btn btn-success btn-circle btn-sm mr-1" rippleEffect>
                        <i class="fa fa-plus"></i>
                    </button>
                    <button (click)="deleteItem(i)" type="button" class="btn btn-danger btn-circle btn-sm" rippleEffect *ngIf="items_languages.length > 0">
                        <i class="fa fa-minus"></i>
                    </button>
                </div>
            </div>
            <div class="row pr-md-2 pt-2">
                <div class="col-12 d-flex justify-content-end mb-4">
                    <button (click)="save()" type="submit" class="btn btn-primary">{{"NEXT" | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</section>


